// extracted by mini-css-extract-plugin
export default {"root":"style_root__pLa7F","image":"style_image__016tv","loader":"style_loader__7Kv7o","processingImage":"style_processingImage__17Q2Q","shine":"style_shine__UC9xA"};